export const AUDITORY_MODEL = {
  paso: 4,
  pasoDescripcion: 'PASO_DIRECCION',
};
